import Image from "next/image"
import Link from "next/link"
import { Fragment } from "react"
import { getPlatformIcon } from "../../utils/platformIcons"

const GameIconTag = (props: any) => {
        const tag  = props.tag
        const disableLink = Boolean(props.disableLink)
        const chip = Boolean(props.chip)
        const playStation = "PlayStation"
        const xBox = "Xbox"
        const duplicateTag = []
        const desiredOrder = ['Nintendo Switch', 'Android', 'iOS', 'PC', 'Game Boy', 'STADIA', 'PlayStation2', 'PlayStation 5', 'PlayStation 4', 'Xbox One', 'Xbox Series X/S', ];
        if (tag) {
        const customSort = (item1, item2) => {
            const index1 = desiredOrder.indexOf(item1.title);
            const index2 = desiredOrder.indexOf(item2.title);
            return index1 - index2;
            };
        const sortedArray = tag.sort(customSort);

            let psicon = -1
            let xboxicon = -1
                for(let i = 0; i < sortedArray.length; i++) {
                if ((sortedArray[i].title.substr(0,11) === playStation )) {
                    psicon = i
                } else if ((sortedArray[i].title.substr(0,4) === xBox)) {
                    xboxicon = i
                }
                else {
                     duplicateTag.push({
                        _id: sortedArray[i]._id,
                        title: sortedArray[i].title,
                        iconUrl: sortedArray[i].iconUrl
                    })
                }
                }

                if ( psicon >= 0)
                duplicateTag.push({
                    _id: sortedArray[psicon]._id,
                    title: sortedArray[psicon].title,
                    iconUrl: sortedArray[psicon].iconUrl
                })
                if ( xboxicon >= 0)
                duplicateTag.push({
                        _id: sortedArray[xboxicon]._id,
                        title: sortedArray[xboxicon].title,
                        iconUrl: sortedArray[xboxicon].iconUrl,
                    })

                }

    // Chip variant — icon on a small hard-edged plate, used over card artwork
    if (chip) {
        return (
            <Fragment>
                {duplicateTag
                    .filter((gameTag: {_id: string, title: string, iconUrl: string}) => Boolean(gameTag.iconUrl))
                    .map((gameTag: {_id: string, title: string, iconUrl: string}) => (
                        <div
                            key={gameTag.title}
                            title={gameTag.title}
                            className="flex items-center justify-center w-6 h-6 rounded-[3px] bg-black/10 ring-1 ring-black/10 flex-shrink-0"
                        >
                            <div className="relative w-4 h-4">
                                {/* Bundled static import when we have one; otherwise the media URL through the loader. */}
                                <Image
                                    src={getPlatformIcon(gameTag.iconUrl) ?? gameTag.iconUrl}
                                    alt={gameTag.title}
                                    fill
                                    sizes="16px"
                                    style={{ objectFit: "contain" }}
                                />
                            </div>
                        </div>
                    ))
                }
            </Fragment>
        )
    }

    // Default variant — bare icon block (existing behaviour, unchanged)
    return (
        <Fragment>
            {
                duplicateTag
                .filter((gameTag: {_id: string, title: string, iconUrl: string}) => Boolean(gameTag.iconUrl))
                .map((gameTag: {_id: string, title: string, iconUrl: string}) => (
                    disableLink ? (
                        <div
                            key={gameTag.title}
                            className="my-auto relative w-5 h-5 block"
                            aria-hidden="true">
                            <Image src={getPlatformIcon(gameTag.iconUrl) ?? gameTag.iconUrl} alt={gameTag.title} fill sizes="20px" style={{ objectFit: "contain" }}/>
                        </div>
                    ) : (
                        <Link
                            key={gameTag.title}
                            href={`/tag/${gameTag._id}?type=platform&title=${encodeURIComponent(gameTag.title)}`}
                            className="my-auto relative w-5 h-5 block cursor-pointer transition-opacity hover:opacity-70 before:content-[''] before:absolute before:-top-3 before:-bottom-3 before:-left-3 before:-right-3">

                            <Image src={getPlatformIcon(gameTag.iconUrl) ?? gameTag.iconUrl} alt={gameTag.title} fill sizes="20px" style={{ objectFit: "contain" }}/>

                        </Link>
                    )
                ))
            }
        </Fragment>
    );
}

export default GameIconTag
